/* tslint:disable */
/* eslint-disable */
/**
 * ExternalConnectionsAPI API
 * ExternalConnectionsAPI manages external connections.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ComputePermissionsRequest } from '../models';
// @ts-ignore
import type { ComputePermissionsResponse } from '../models';
// @ts-ignore
import type { Connection } from '../models';
// @ts-ignore
import type { GetOnboardingCommandRequest } from '../models';
// @ts-ignore
import type { GetOnboardingCommandResponse } from '../models';
// @ts-ignore
import type { ListConnectionsResponse } from '../models';
// @ts-ignore
import type { ListFeaturesResponse } from '../models';
// @ts-ignore
import type { ProvisionCastPrincipalsRequest } from '../models';
// @ts-ignore
import type { ProvisionCastPrincipalsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpsertConnectionRequest } from '../models';
// @ts-ignore
import type { UpsertConnectionResponse } from '../models';
/**
 * ExternalConnectionsAPIApi - axios parameter creator
 * @export
 */
export const ExternalConnectionsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the flat list of IAM permissions required for the selected features and cloud provider.  This is a read-only, stateless endpoint - it does not depend on any existing connection or customer setup.
         * @param {ComputePermissionsRequest} computePermissionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIComputePermissions: async (computePermissionsRequest: ComputePermissionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'computePermissionsRequest' is not null or undefined
            assertParamExists('externalConnectionsAPIComputePermissions', 'computePermissionsRequest', computePermissionsRequest)
            const localVarPath = `/external-connections/v1beta/permissions:compute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(computePermissionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a connection.
         * @param {string} organizationId The organization ID the connection belongs to.
         * @param {string} id The ID of the connection to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIDeleteConnection: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('externalConnectionsAPIDeleteConnection', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('externalConnectionsAPIDeleteConnection', 'id', id)
            const localVarPath = `/external-connections/v1beta/organizations/{organizationId}/connections/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a connection by ID.
         * @param {string} organizationId The organization ID the connection belongs to.
         * @param {string} id The connection ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIGetConnection: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('externalConnectionsAPIGetConnection', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('externalConnectionsAPIGetConnection', 'id', id)
            const localVarPath = `/external-connections/v1beta/organizations/{organizationId}/connections/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a runnable castctl cloud connect command for the requested setup.  The command includes the caller\'s API token and all flags needed to provision  customer-side IAM and confirm the connection.
         * @param {string} organizationId The organization requesting the connection setup command.
         * @param {GetOnboardingCommandRequest} getOnboardingCommandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIGetOnboardingCommand: async (organizationId: string, getOnboardingCommandRequest: GetOnboardingCommandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('externalConnectionsAPIGetOnboardingCommand', 'organizationId', organizationId)
            // verify required parameter 'getOnboardingCommandRequest' is not null or undefined
            assertParamExists('externalConnectionsAPIGetOnboardingCommand', 'getOnboardingCommandRequest', getOnboardingCommandRequest)
            const localVarPath = `/external-connections/v1beta/organizations/{organizationId}/connections:getOnboardingCommand`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOnboardingCommandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists connections for an organization.
         * @param {string} organizationId The organization ID to list connections for.
         * @param {ExternalConnectionsAPIListConnectionsFilterCloudEnum} [filterCloud] Filter by cloud provider.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIListConnections: async (organizationId: string, filterCloud?: ExternalConnectionsAPIListConnectionsFilterCloudEnum, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('externalConnectionsAPIListConnections', 'organizationId', organizationId)
            const localVarPath = `/external-connections/v1beta/organizations/{organizationId}/connections`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filterCloud !== undefined) {
                localVarQueryParameter['filter.cloud'] = filterCloud;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all available features.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<ExternalConnectionsAPIListFeaturesCloudsEnum>} [clouds] Optional cloud-provider filter. When non-empty, the response is filtered  both at the feature and sub-feature level: sub-features that don\&#39;t  support any of the listed clouds are dropped, and a feature with no  remaining sub-features is dropped entirely.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIListFeatures: async (pageLimit?: string, pageCursor?: string, clouds?: Array<ExternalConnectionsAPIListFeaturesCloudsEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/external-connections/v1beta/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (clouds) {
                localVarQueryParameter['clouds'] = clouds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates Cast-side IAM principals  required before a customer can establish trust with Cast AI.  This is the first step in the connection onboarding flow.  Idempotent — repeated calls with the same input return the same result.  For AWS, this is a no-op (the shared role in Cast\'s AWS account already exists).
         * @param {string} organizationId The organization requesting the connection.
         * @param {ProvisionCastPrincipalsRequest} provisionCastPrincipalsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIProvisionCastPrincipals: async (organizationId: string, provisionCastPrincipalsRequest: ProvisionCastPrincipalsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('externalConnectionsAPIProvisionCastPrincipals', 'organizationId', organizationId)
            // verify required parameter 'provisionCastPrincipalsRequest' is not null or undefined
            assertParamExists('externalConnectionsAPIProvisionCastPrincipals', 'provisionCastPrincipalsRequest', provisionCastPrincipalsRequest)
            const localVarPath = `/external-connections/v1beta/organizations/{organizationId}/cast-principals:provision`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(provisionCastPrincipalsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or updates a connection with the full desired state.  The connection is uniquely identified by organization_id, cloud, and scope_key.  If a connection already exists, it will be replaced with the new state.
         * @param {string} organizationId The organization ID to create/update the connection for.
         * @param {UpsertConnectionRequest} upsertConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIUpsertConnection: async (organizationId: string, upsertConnectionRequest: UpsertConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('externalConnectionsAPIUpsertConnection', 'organizationId', organizationId)
            // verify required parameter 'upsertConnectionRequest' is not null or undefined
            assertParamExists('externalConnectionsAPIUpsertConnection', 'upsertConnectionRequest', upsertConnectionRequest)
            const localVarPath = `/external-connections/v1beta/organizations/{organizationId}/connections:upsert`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalConnectionsAPIApi - functional programming interface
 * @export
 */
export const ExternalConnectionsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalConnectionsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the flat list of IAM permissions required for the selected features and cloud provider.  This is a read-only, stateless endpoint - it does not depend on any existing connection or customer setup.
         * @param {ComputePermissionsRequest} computePermissionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalConnectionsAPIComputePermissions(computePermissionsRequest: ComputePermissionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComputePermissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalConnectionsAPIComputePermissions(computePermissionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalConnectionsAPIApi.externalConnectionsAPIComputePermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a connection.
         * @param {string} organizationId The organization ID the connection belongs to.
         * @param {string} id The ID of the connection to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalConnectionsAPIDeleteConnection(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalConnectionsAPIDeleteConnection(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalConnectionsAPIApi.externalConnectionsAPIDeleteConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a connection by ID.
         * @param {string} organizationId The organization ID the connection belongs to.
         * @param {string} id The connection ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalConnectionsAPIGetConnection(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Connection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalConnectionsAPIGetConnection(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalConnectionsAPIApi.externalConnectionsAPIGetConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a runnable castctl cloud connect command for the requested setup.  The command includes the caller\'s API token and all flags needed to provision  customer-side IAM and confirm the connection.
         * @param {string} organizationId The organization requesting the connection setup command.
         * @param {GetOnboardingCommandRequest} getOnboardingCommandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalConnectionsAPIGetOnboardingCommand(organizationId: string, getOnboardingCommandRequest: GetOnboardingCommandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOnboardingCommandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalConnectionsAPIGetOnboardingCommand(organizationId, getOnboardingCommandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalConnectionsAPIApi.externalConnectionsAPIGetOnboardingCommand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists connections for an organization.
         * @param {string} organizationId The organization ID to list connections for.
         * @param {ExternalConnectionsAPIListConnectionsFilterCloudEnum} [filterCloud] Filter by cloud provider.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalConnectionsAPIListConnections(organizationId: string, filterCloud?: ExternalConnectionsAPIListConnectionsFilterCloudEnum, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListConnectionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalConnectionsAPIListConnections(organizationId, filterCloud, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalConnectionsAPIApi.externalConnectionsAPIListConnections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all available features.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<ExternalConnectionsAPIListFeaturesCloudsEnum>} [clouds] Optional cloud-provider filter. When non-empty, the response is filtered  both at the feature and sub-feature level: sub-features that don\&#39;t  support any of the listed clouds are dropped, and a feature with no  remaining sub-features is dropped entirely.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalConnectionsAPIListFeatures(pageLimit?: string, pageCursor?: string, clouds?: Array<ExternalConnectionsAPIListFeaturesCloudsEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListFeaturesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalConnectionsAPIListFeatures(pageLimit, pageCursor, clouds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalConnectionsAPIApi.externalConnectionsAPIListFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates Cast-side IAM principals  required before a customer can establish trust with Cast AI.  This is the first step in the connection onboarding flow.  Idempotent — repeated calls with the same input return the same result.  For AWS, this is a no-op (the shared role in Cast\'s AWS account already exists).
         * @param {string} organizationId The organization requesting the connection.
         * @param {ProvisionCastPrincipalsRequest} provisionCastPrincipalsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalConnectionsAPIProvisionCastPrincipals(organizationId: string, provisionCastPrincipalsRequest: ProvisionCastPrincipalsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProvisionCastPrincipalsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalConnectionsAPIProvisionCastPrincipals(organizationId, provisionCastPrincipalsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalConnectionsAPIApi.externalConnectionsAPIProvisionCastPrincipals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates or updates a connection with the full desired state.  The connection is uniquely identified by organization_id, cloud, and scope_key.  If a connection already exists, it will be replaced with the new state.
         * @param {string} organizationId The organization ID to create/update the connection for.
         * @param {UpsertConnectionRequest} upsertConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalConnectionsAPIUpsertConnection(organizationId: string, upsertConnectionRequest: UpsertConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalConnectionsAPIUpsertConnection(organizationId, upsertConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalConnectionsAPIApi.externalConnectionsAPIUpsertConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalConnectionsAPIApi - factory interface
 * @export
 */
export const ExternalConnectionsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalConnectionsAPIApiFp(configuration)
    return {
        /**
         * Returns the flat list of IAM permissions required for the selected features and cloud provider.  This is a read-only, stateless endpoint - it does not depend on any existing connection or customer setup.
         * @param {ExternalConnectionsAPIApiExternalConnectionsAPIComputePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIComputePermissions(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIComputePermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ComputePermissionsResponse> {
            return localVarFp.externalConnectionsAPIComputePermissions(requestParameters.computePermissionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a connection.
         * @param {ExternalConnectionsAPIApiExternalConnectionsAPIDeleteConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIDeleteConnection(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIDeleteConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.externalConnectionsAPIDeleteConnection(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a connection by ID.
         * @param {ExternalConnectionsAPIApiExternalConnectionsAPIGetConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIGetConnection(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIGetConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Connection> {
            return localVarFp.externalConnectionsAPIGetConnection(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a runnable castctl cloud connect command for the requested setup.  The command includes the caller\'s API token and all flags needed to provision  customer-side IAM and confirm the connection.
         * @param {ExternalConnectionsAPIApiExternalConnectionsAPIGetOnboardingCommandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIGetOnboardingCommand(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIGetOnboardingCommandRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOnboardingCommandResponse> {
            return localVarFp.externalConnectionsAPIGetOnboardingCommand(requestParameters.organizationId, requestParameters.getOnboardingCommandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists connections for an organization.
         * @param {ExternalConnectionsAPIApiExternalConnectionsAPIListConnectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIListConnections(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIListConnectionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListConnectionsResponse> {
            return localVarFp.externalConnectionsAPIListConnections(requestParameters.organizationId, requestParameters.filterCloud, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all available features.
         * @param {ExternalConnectionsAPIApiExternalConnectionsAPIListFeaturesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIListFeatures(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIListFeaturesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListFeaturesResponse> {
            return localVarFp.externalConnectionsAPIListFeatures(requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.clouds, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates Cast-side IAM principals  required before a customer can establish trust with Cast AI.  This is the first step in the connection onboarding flow.  Idempotent — repeated calls with the same input return the same result.  For AWS, this is a no-op (the shared role in Cast\'s AWS account already exists).
         * @param {ExternalConnectionsAPIApiExternalConnectionsAPIProvisionCastPrincipalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIProvisionCastPrincipals(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIProvisionCastPrincipalsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProvisionCastPrincipalsResponse> {
            return localVarFp.externalConnectionsAPIProvisionCastPrincipals(requestParameters.organizationId, requestParameters.provisionCastPrincipalsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or updates a connection with the full desired state.  The connection is uniquely identified by organization_id, cloud, and scope_key.  If a connection already exists, it will be replaced with the new state.
         * @param {ExternalConnectionsAPIApiExternalConnectionsAPIUpsertConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalConnectionsAPIUpsertConnection(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIUpsertConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpsertConnectionResponse> {
            return localVarFp.externalConnectionsAPIUpsertConnection(requestParameters.organizationId, requestParameters.upsertConnectionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for externalConnectionsAPIComputePermissions operation in ExternalConnectionsAPIApi.
 * @export
 * @interface ExternalConnectionsAPIApiExternalConnectionsAPIComputePermissionsRequest
 */
export interface ExternalConnectionsAPIApiExternalConnectionsAPIComputePermissionsRequest {
    /**
     * 
     * @type {ComputePermissionsRequest}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIComputePermissions
     */
    readonly computePermissionsRequest: ComputePermissionsRequest
}

/**
 * Request parameters for externalConnectionsAPIDeleteConnection operation in ExternalConnectionsAPIApi.
 * @export
 * @interface ExternalConnectionsAPIApiExternalConnectionsAPIDeleteConnectionRequest
 */
export interface ExternalConnectionsAPIApiExternalConnectionsAPIDeleteConnectionRequest {
    /**
     * The organization ID the connection belongs to.
     * @type {string}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIDeleteConnection
     */
    readonly organizationId: string

    /**
     * The ID of the connection to delete.
     * @type {string}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIDeleteConnection
     */
    readonly id: string
}

/**
 * Request parameters for externalConnectionsAPIGetConnection operation in ExternalConnectionsAPIApi.
 * @export
 * @interface ExternalConnectionsAPIApiExternalConnectionsAPIGetConnectionRequest
 */
export interface ExternalConnectionsAPIApiExternalConnectionsAPIGetConnectionRequest {
    /**
     * The organization ID the connection belongs to.
     * @type {string}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIGetConnection
     */
    readonly organizationId: string

    /**
     * The connection ID.
     * @type {string}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIGetConnection
     */
    readonly id: string
}

/**
 * Request parameters for externalConnectionsAPIGetOnboardingCommand operation in ExternalConnectionsAPIApi.
 * @export
 * @interface ExternalConnectionsAPIApiExternalConnectionsAPIGetOnboardingCommandRequest
 */
export interface ExternalConnectionsAPIApiExternalConnectionsAPIGetOnboardingCommandRequest {
    /**
     * The organization requesting the connection setup command.
     * @type {string}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIGetOnboardingCommand
     */
    readonly organizationId: string

    /**
     * 
     * @type {GetOnboardingCommandRequest}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIGetOnboardingCommand
     */
    readonly getOnboardingCommandRequest: GetOnboardingCommandRequest
}

/**
 * Request parameters for externalConnectionsAPIListConnections operation in ExternalConnectionsAPIApi.
 * @export
 * @interface ExternalConnectionsAPIApiExternalConnectionsAPIListConnectionsRequest
 */
export interface ExternalConnectionsAPIApiExternalConnectionsAPIListConnectionsRequest {
    /**
     * The organization ID to list connections for.
     * @type {string}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIListConnections
     */
    readonly organizationId: string

    /**
     * Filter by cloud provider.
     * @type {'CLOUD_UNSPECIFIED' | 'GCP' | 'AWS' | 'AZURE' | 'ORACLE' | 'NEBIUS'}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIListConnections
     */
    readonly filterCloud?: ExternalConnectionsAPIListConnectionsFilterCloudEnum

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIListConnections
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIListConnections
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for externalConnectionsAPIListFeatures operation in ExternalConnectionsAPIApi.
 * @export
 * @interface ExternalConnectionsAPIApiExternalConnectionsAPIListFeaturesRequest
 */
export interface ExternalConnectionsAPIApiExternalConnectionsAPIListFeaturesRequest {
    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIListFeatures
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIListFeatures
     */
    readonly pageCursor?: string

    /**
     * Optional cloud-provider filter. When non-empty, the response is filtered  both at the feature and sub-feature level: sub-features that don\&#39;t  support any of the listed clouds are dropped, and a feature with no  remaining sub-features is dropped entirely.
     * @type {Array<'CLOUD_UNSPECIFIED' | 'GCP' | 'AWS' | 'AZURE' | 'ORACLE' | 'NEBIUS'>}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIListFeatures
     */
    readonly clouds?: Array<ExternalConnectionsAPIListFeaturesCloudsEnum>
}

/**
 * Request parameters for externalConnectionsAPIProvisionCastPrincipals operation in ExternalConnectionsAPIApi.
 * @export
 * @interface ExternalConnectionsAPIApiExternalConnectionsAPIProvisionCastPrincipalsRequest
 */
export interface ExternalConnectionsAPIApiExternalConnectionsAPIProvisionCastPrincipalsRequest {
    /**
     * The organization requesting the connection.
     * @type {string}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIProvisionCastPrincipals
     */
    readonly organizationId: string

    /**
     * 
     * @type {ProvisionCastPrincipalsRequest}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIProvisionCastPrincipals
     */
    readonly provisionCastPrincipalsRequest: ProvisionCastPrincipalsRequest
}

/**
 * Request parameters for externalConnectionsAPIUpsertConnection operation in ExternalConnectionsAPIApi.
 * @export
 * @interface ExternalConnectionsAPIApiExternalConnectionsAPIUpsertConnectionRequest
 */
export interface ExternalConnectionsAPIApiExternalConnectionsAPIUpsertConnectionRequest {
    /**
     * The organization ID to create/update the connection for.
     * @type {string}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIUpsertConnection
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpsertConnectionRequest}
     * @memberof ExternalConnectionsAPIApiExternalConnectionsAPIUpsertConnection
     */
    readonly upsertConnectionRequest: UpsertConnectionRequest
}

/**
 * ExternalConnectionsAPIApi - object-oriented interface
 * @export
 * @class ExternalConnectionsAPIApi
 * @extends {BaseAPI}
 */
export class ExternalConnectionsAPIApi extends BaseAPI {
    /**
     * Returns the flat list of IAM permissions required for the selected features and cloud provider.  This is a read-only, stateless endpoint - it does not depend on any existing connection or customer setup.
     * @param {ExternalConnectionsAPIApiExternalConnectionsAPIComputePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalConnectionsAPIApi
     */
    public externalConnectionsAPIComputePermissions(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIComputePermissionsRequest, options?: RawAxiosRequestConfig) {
        return ExternalConnectionsAPIApiFp(this.configuration).externalConnectionsAPIComputePermissions(requestParameters.computePermissionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a connection.
     * @param {ExternalConnectionsAPIApiExternalConnectionsAPIDeleteConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalConnectionsAPIApi
     */
    public externalConnectionsAPIDeleteConnection(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIDeleteConnectionRequest, options?: RawAxiosRequestConfig) {
        return ExternalConnectionsAPIApiFp(this.configuration).externalConnectionsAPIDeleteConnection(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a connection by ID.
     * @param {ExternalConnectionsAPIApiExternalConnectionsAPIGetConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalConnectionsAPIApi
     */
    public externalConnectionsAPIGetConnection(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIGetConnectionRequest, options?: RawAxiosRequestConfig) {
        return ExternalConnectionsAPIApiFp(this.configuration).externalConnectionsAPIGetConnection(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a runnable castctl cloud connect command for the requested setup.  The command includes the caller\'s API token and all flags needed to provision  customer-side IAM and confirm the connection.
     * @param {ExternalConnectionsAPIApiExternalConnectionsAPIGetOnboardingCommandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalConnectionsAPIApi
     */
    public externalConnectionsAPIGetOnboardingCommand(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIGetOnboardingCommandRequest, options?: RawAxiosRequestConfig) {
        return ExternalConnectionsAPIApiFp(this.configuration).externalConnectionsAPIGetOnboardingCommand(requestParameters.organizationId, requestParameters.getOnboardingCommandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists connections for an organization.
     * @param {ExternalConnectionsAPIApiExternalConnectionsAPIListConnectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalConnectionsAPIApi
     */
    public externalConnectionsAPIListConnections(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIListConnectionsRequest, options?: RawAxiosRequestConfig) {
        return ExternalConnectionsAPIApiFp(this.configuration).externalConnectionsAPIListConnections(requestParameters.organizationId, requestParameters.filterCloud, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all available features.
     * @param {ExternalConnectionsAPIApiExternalConnectionsAPIListFeaturesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalConnectionsAPIApi
     */
    public externalConnectionsAPIListFeatures(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIListFeaturesRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalConnectionsAPIApiFp(this.configuration).externalConnectionsAPIListFeatures(requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.clouds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates Cast-side IAM principals  required before a customer can establish trust with Cast AI.  This is the first step in the connection onboarding flow.  Idempotent — repeated calls with the same input return the same result.  For AWS, this is a no-op (the shared role in Cast\'s AWS account already exists).
     * @param {ExternalConnectionsAPIApiExternalConnectionsAPIProvisionCastPrincipalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalConnectionsAPIApi
     */
    public externalConnectionsAPIProvisionCastPrincipals(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIProvisionCastPrincipalsRequest, options?: RawAxiosRequestConfig) {
        return ExternalConnectionsAPIApiFp(this.configuration).externalConnectionsAPIProvisionCastPrincipals(requestParameters.organizationId, requestParameters.provisionCastPrincipalsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or updates a connection with the full desired state.  The connection is uniquely identified by organization_id, cloud, and scope_key.  If a connection already exists, it will be replaced with the new state.
     * @param {ExternalConnectionsAPIApiExternalConnectionsAPIUpsertConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalConnectionsAPIApi
     */
    public externalConnectionsAPIUpsertConnection(requestParameters: ExternalConnectionsAPIApiExternalConnectionsAPIUpsertConnectionRequest, options?: RawAxiosRequestConfig) {
        return ExternalConnectionsAPIApiFp(this.configuration).externalConnectionsAPIUpsertConnection(requestParameters.organizationId, requestParameters.upsertConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ExternalConnectionsAPIListConnectionsFilterCloudEnum = {
    CLOUD_UNSPECIFIED: 'CLOUD_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    AZURE: 'AZURE',
    ORACLE: 'ORACLE',
    NEBIUS: 'NEBIUS'
} as const;
export type ExternalConnectionsAPIListConnectionsFilterCloudEnum = typeof ExternalConnectionsAPIListConnectionsFilterCloudEnum[keyof typeof ExternalConnectionsAPIListConnectionsFilterCloudEnum];
/**
 * @export
 */
export const ExternalConnectionsAPIListFeaturesCloudsEnum = {
    CLOUD_UNSPECIFIED: 'CLOUD_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    AZURE: 'AZURE',
    ORACLE: 'ORACLE',
    NEBIUS: 'NEBIUS'
} as const;
export type ExternalConnectionsAPIListFeaturesCloudsEnum = typeof ExternalConnectionsAPIListFeaturesCloudsEnum[keyof typeof ExternalConnectionsAPIListFeaturesCloudsEnum];
